import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#5C4033",      // Warm brown – antique feel
      light: "#8B6F5E",
      dark: "#3E2723",
      contrastText: "#fff",
    },
    secondary: {
      main: "#C8A96E",      // Antique gold
      light: "#DCC99E",
      dark: "#A68B4B",
      contrastText: "#000",
    },
    background: {
      default: "#FAF7F2",   // Warm off-white
      paper: "#FFFFFF",
    },
    success: {
      main: "#4CAF50",
    },
    warning: {
      main: "#FF9800",
    },
    info: {
      main: "#2196F3",
    },
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
        },
      },
    },
  },
});

export default theme;
